import { motion } from "framer-motion";

const HERO_GRAPHIC =
  "https://customer-assets.emergentagent.com/job_creative-market-76/artifacts/fqh2tshy_email1783908397780image9.png";

const fadeUp = {
  initial: { opacity: 0, y: 30 },
  animate: { opacity: 1, y: 0 },
};

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-32 md:pt-40 pb-20 md:pb-28 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto w-full px-6 md:px-12">
        {/* eyebrow */}
        <motion.div
          {...fadeUp}
          transition={{ duration: 0.7, delay: 0.05 }}
          className="flex items-center gap-3"
        >
          <span className="w-8 h-px bg-[#1C1B1A]"></span>
          <span className="font-mono-label text-[#635F59]">
            Marketing · Social Media · Design
          </span>
        </motion.div>

        {/* headline + visual */}
        <div className="mt-8 md:mt-12 grid grid-cols-12 gap-10 lg:gap-12 items-center">
          <div className="col-span-12 lg:col-span-7">
            <motion.h1
              {...fadeUp}
              transition={{ duration: 0.8, delay: 0.1 }}
              data-testid="hero-headline"
              className="font-serif-display text-5xl sm:text-6xl md:text-7xl lg:text-[88px] leading-[0.95] tracking-tighter font-medium"
            >
              Marketing that
              <br className="hidden sm:block" />
              gets you
              <span className="italic text-[#B4A087]"> noticed.</span>
            </motion.h1>

            <motion.p
              {...fadeUp}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="mt-8 text-base md:text-lg leading-relaxed text-[#635F59] max-w-xl"
            >
              Whitney Jean &amp; Co. helps local businesses — restaurants,
              salons, contractors, realtors and more — grow through strategic
              social media, content creation, and professional branding.
            </motion.p>

            <motion.div
              {...fadeUp}
              transition={{ duration: 0.8, delay: 0.3 }}
              className="mt-9 flex flex-wrap items-center gap-4"
            >
              <a
                href="#contact"
                data-testid="hero-primary-cta"
                className="inline-flex items-center gap-3 bg-[#1C1B1A] text-[#FBF9F6] px-7 py-4 text-sm hover:bg-[#33312E] transition-colors"
              >
                Book a free consultation
                <span aria-hidden>→</span>
              </a>
              <a
                href="#pricing"
                data-testid="hero-secondary-cta"
                className="inline-flex items-center gap-2 text-sm border-b border-[#1C1B1A]/40 hover:border-[#1C1B1A] pb-1 transition-colors"
              >
                View services &amp; pricing
              </a>
            </motion.div>

            <div className="mt-12 flex flex-wrap items-center gap-x-10 gap-y-4">
              {["Social Media", "Branding & Design", "Content", "Campaigns"].map(
                (t) => (
                  <span key={t} className="font-mono-label text-[#635F59]">
                    {t}
                  </span>
                )
              )}
            </div>
          </div>

          {/* Brand graphic poster */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.35 }}
            className="col-span-12 lg:col-span-5"
          >
            <div className="wj-image-hover relative overflow-hidden border border-[#E5E0D8] bg-[#F2EEE9] max-w-md mx-auto lg:mx-0 lg:ml-auto">
              <img
                src={HERO_GRAPHIC}
                alt="Whitney Jean & Co. branding and design"
                className="w-full h-auto block"
                loading="eager"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
